exports.FIREBASE_CONFIG = {
  apiKey: "AIzaSyChCAOaueS2KT2j7skNKPf05bpHYnFF9xY",
  authDomain: "scaledesk-conductor.firebaseapp.com",
  databaseURL: "https://scaledesk-conductor.firebaseio.com",
  projectId: "scaledesk-conductor",
  storageBucket: "scaledesk-conductor.appspot.com",
  messagingSenderId: "87200838744",
  appId: "1:87200838744:web:cf17796f205ade256f462d",
  measurementId: "G-YRSN7PP37W",
};

exports.BASIC_URL = "https://scaledesk-conductor.ngrok.io/";

exports.DEFAULT_CONTACT_EMAIL = "hello@scaledesk.io";

exports.STRIPE_CLIENT_ID = "ca_H0TjsDVIjZZXR8kLmyPMEa7PGvu6s5jO";

exports.HEELOSIGN_CLIENT_ID = "cb796e3b6617e3c5b33f4d2ef3f5cea6";

exports.CALENDLY_URL = "https://calendly.com/juanitops/15min";

// exports.GOOGLE_MAP_KEY = 'AIzaSyDTap6Odeo1zXTVDLEcoZMvLhc9M2y7Xno';
exports.GOOGLE_MAP_KEY = "AIzaSyChCAOaueS2KT2j7skNKPf05bpHYnFF9xY";

// exports.FIREBASE_CONFIG = {
//   apiKey: "AIzaSyDDVR1A-ngsgHlEAxL9d4bJPjC89IOYCkQ",
//   authDomain: "conductor-8aba1.firebaseapp.com",
//   databaseURL: "https://conductor-8aba1.firebaseio.com",
//   projectId: "conductor-8aba1",
//   storageBucket: "conductor-8aba1.appspot.com",
//   messagingSenderId: "725123354020",
//   appId: "1:725123354020:web:76226d4032841098298531",
//   measurementId: "G-0WK0MRQC00"
// };
//
// exports.BASIC_URL = "https://conductor-8aba1.appspot.com/";
//
// exports.DEFAULT_CONTACT_EMAIL = "scheduling@officeiq.io";
//
// exports.STRIPE_CLIENT_ID = "ca_AoX5qRcLsDtb1o9l8QpxNtlNzJBMn5XE";
//
// exports.HEELOSIGN_CLIENT_ID = "6d03853eb0154596e8cd7611f0ab7406";
//
// exports.CALENDLY_URL = "https://calendly.com/qiyisi/test";
//
// exports.GOOGLE_MAP_KEY = 'AIzaSyDTap6Odeo1zXTVDLEcoZMvLhc9M2y7Xno';
